export default function isFromSurveyLocationUtil () {
  return /utm_source=survey/gi.test(window.location.search)
}
